import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, HostListener } from '@angular/core';
import { IVehicleSwType } from './models/vehicle-sw-type.model';
import { IVehicleBrand } from './models/vehicle-brand.model';
import { Subscription } from 'rxjs';
import { IVehicleTestableSw } from './models/vehicle-testable-sw.model';
import { IVehicleContentShowType } from './models/vehicle-content-show-type.model';
import { VehicleTestableSwService } from './services/vehicle-testable-sw.service';
import { VehicleBrandService } from './services/vehicle-brand.service';
import { VehicleSwTypeService } from './services/vehicle-sw-type.service';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Params, ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/api/selectitem';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    @ViewChild('tpl')
    tpl: TemplateRef<any>;
    @ViewChild('tplr')
    tplr: TemplateRef<any>;

  title = 'eucleia-autolist';
  vehicleSwTypes: IVehicleSwType[];
  brands: IVehicleBrand[] = []; // 品牌列表
  lang = 'CN';
  vehicleTestableSws: IVehicleTestableSw[] = []; // 内容
  currentAccount: any;
  eventSubscriber: Subscription;
  selectedBrand: IVehicleBrand;
  selectedType: IVehicleSwType;
  brandCols: any = [{header: '品牌', field: 'name'}];
  isHead = false;
  from: string;
  cols: any[] = [];

  versions: any;
  filterItems: any[][] = [];
  selectedFilterItems: string[] = [];
  selectedShowCols: string[] = [];
  display = false;
  isLoading = false;
  dialog = {title: '', curLatestVersionInfo: ''};
  selectedBrandType: IVehicleContentShowType;

  specialVehicleContents: any; // 特殊功能
  filters: SelectItem[];
  first = 0;
  rowsPerPage = 15;
  currentPage = 1;
  showCols = [];
  vehicleSws = [];
  headerValues;

  resetting = false;
  filterChanged = false;

  showColumnsSelectBox = false;

  debug = false;
  preventScroll = true;
    touchContent: boolean;
  constructor(
    private titleService: Title,
    protected vehicleTestableSwService: VehicleTestableSwService,
    protected vehicleBrandService: VehicleBrandService,
    protected vehicleSwTypeService: VehicleSwTypeService,
    protected activeRoute: ActivatedRoute
  ) {}

  loadAll() {
      this.isLoading = true;
      this.selectedShowCols = [];
      this.vehicleTestableSws = [];
      this.cols = [];
      this.filterItems = [];
      this.filters = [];
      this.showCols = [];

      const headTypeCode = this.selectedBrandType.code === '4' ? 40 : 0;
      this.vehicleTestableSwService.query({
          brandId: this.selectedBrand.id,
          typeCode: headTypeCode
      }).subscribe(
          (res: HttpResponse<IVehicleTestableSw[]>) => {
              const vehicleTestableSwsHeader = res.body;
              if (vehicleTestableSwsHeader && vehicleTestableSwsHeader.length > 0) {
                  this.headerValues = vehicleTestableSwsHeader[0];
                  this.loadContent();
                  this.buildColums();
              } else {
                  this.isLoading = false;
              }
          },
          (res: HttpErrorResponse) => this.onError(res.message)
      );

      // 获取当前车型的特殊功能
      this.vehicleTestableSwService.query({
          brandId: this.selectedBrand.id,
          typeCode: '2'
      }).subscribe(
          (res: HttpResponse<IVehicleTestableSw[]>) => {
              const vehicleTestableSwsSpecial = res.body;
              if (vehicleTestableSwsSpecial && vehicleTestableSwsSpecial.length > 0) {
                  this.buildSpecials(vehicleTestableSwsSpecial);
              } else {
                this.specialVehicleContents = undefined;
              }
          },
          (res: HttpErrorResponse) => this.onError(res.message)
      );

  }

  loadContent() {
    this.vehicleTestableSwService.query({
        brandId: this.selectedBrand.id,
        typeCode: this.selectedBrandType.code
    }).subscribe(
        (res: HttpResponse<IVehicleTestableSw[]>) => {
            this.vehicleSws = res.body || [];
            // console.log('0----->', this.vehicleSws, this.vehicleTestableSws);
            if (this.vehicleSws.length < 1) {
                this.vehicleTestableSws = [];
                this.filterItems = [];
            } else {
                this.buildContentAndFilters();
            }
            this.isLoading = false;
        },
        (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  // 构造代码：描述数组
  buildSpecials(specials) {
      const lspecials = {};
      if (this.debug) { window.console.log( '______specials = ', lspecials)};
      specials.forEach(special => {
          const arrSpecials: any[] = special.content.split('|');
          lspecials[arrSpecials[0]] = arrSpecials[1];
      });

      this.specialVehicleContents = lspecials;
  }

  ngOnInit() {
      // this.loadAll();
    this.activeRoute.queryParams.subscribe((params: Params) => {
        this.lang = params['lang'];
        this.from = params['from'];
        const blang = (navigator.language).toLowerCase();
        console.log('blang ===', blang);
        if(this.lang === undefined) {
            // const browserLang = this.translateService.getBrowserLang();
            if (blang.indexOf('zh') >= 0) {
                this.lang = 'CN';
            } else {
                this.lang = 'EN';
            }
            // window.console.log('browerLang = ', browserLang);
        }

        if (this.lang.toUpperCase() === 'CN') {
            this.titleService.setTitle('欧克勒亚车型查询系统');
        } else {
            this.titleService.setTitle('Eucleia Vehicle Inquiry System');
        }
    });

    // this.vehicleBrandService.getLatestSoftwareVersions(
    //       {langCode: this.lang}
    //   ).subscribe(
    //       (res: HttpResponse<any>) => {
    //           this.versions = res.body;
    //           // if (this.debug) { window.console.log(this.versions);
    //       },
    //       (res: HttpErrorResponse) => this.onError(res.message)
    //   );

    this.vehicleSwTypeService.query().subscribe(
          (res: HttpResponse<IVehicleSwType[]>) => {
              this.vehicleSwTypes = res.body;
            //   this.selectedType = this.vehicleSwTypes[0];
            //   this.loadBrand(this.selectedType.id);
          },
          (res: HttpErrorResponse) => this.onError(res.message)
      );

    function preventDefault(e) {
        window.console.log(this.touchContent, e);
        e.preventDefault();
        e.stopImmediatePropagation();

    }

    const touchstart = (e) => {
        if (this.display && !this.touchContent) {
            document.addEventListener('touchstart', preventDefault, { passive: false });
            document.addEventListener('touchmove',  preventDefault, { passive: false });
        }
        /*do other stuff*/
    };
    const touchend = (e) => {
        if (this.display) {
            document.removeEventListener('touchstart', preventDefault, false);
            document.removeEventListener('touchmove',  preventDefault, false);
        }

        this.touchContent = false;
    };

    document.body.addEventListener('touchstart',  touchstart, { passive: false });
    document.body.addEventListener('touchend',    touchend,   { passive: false });

  }

  onClose() {
      window.console.log('close.........');
  }

  onHideDialog() {
    window.console.log('on hide.........');
  }

  loadBrand(typeId: any) {
    this.selectedBrand = null;
    this.vehicleTestableSws = [];
    this.filterItems = [];
    this.filters = [];
    this.selectedShowCols = [];
    this.cols = [];
    this.vehicleBrandService.query({
        langCode: this.lang,
        typeId
    }).subscribe(
        (res1: HttpResponse<IVehicleBrand[]>) => {
            this.brands = res1.body;
            if (this.debug) { window.console.log(this.brands, this.selectedShowCols); }
            if (this.brands.length > 0) {
            //   this.selectedBrand = this.brands[0];
            //   this.selectedBrandType = this.selectedBrand.types[0];
            //   this.loadAll();
            }
        },
        (res1: HttpErrorResponse) => this.onError(res1.message)
    );
  }

  ngOnDestroy() {
      if (this.display) {
          this.display = false;
      }
  }

  trackId(index: number, item: IVehicleTestableSw) {
      return item.id;
  }

  protected onError(errorMessage: string) {
      // this.jhiAlertService.error(errorMessage, null, null);
      this.isLoading = false;
  }

  buildColums() {
      const headerValues = this.headerValues;
      const cols = [];
      const filters = [];
      if (this.headerValues === undefined ) { return; }
      const header = headerValues.content.split('|');
      for (let i = 0; i < header.length; i++) {
          const fileld = 'content' + i;
          const col = {
              field: fileld,
              header: header[i]
          };

          const filter = {
              label: header[i],
              value: fileld
          };

          cols.push(col);
          filters.push(filter);
      }

      this.cols = cols;

    //   console.log(this.cols,this.filters );
      this.filters = filters;
      this.showCols = this.filters;
    //   console.log(this.selectedShowCols, this.filters );
  }

  buildContentAndFilters() {
      const datas = this.vehicleSws;
      // 先获取列数
      if (datas && datas.length > 0) {

          const colNums = datas[0].content.split('|').length;
        //   const selectedFilterItems: string[] = [];
          const filterItems: any[][] = [];
          const vehicleTestableSws: IVehicleTestableSw[] = [];
        //   for (let j = 0; j < this.cols.length; j++) {
        //     console.log('====', this.selectedFilterItems[j]);
        //   }
          for (let i = 0; i < datas.length; i++) {
              const contentItem: any = {};

              const content = datas[i].content;

              const contents = content.split('|');

              // 先判断当前行中每列是否已经包括，如果已经，过滤掉
              if (this.selectedFilterItems.length > 0) {
                  let foundFiltered = false;
                  // 选择过,开始过滤掉选择的行
                  for (let j = 0; j < this.cols.length; j++) {

                    if (contents[j] === undefined) {
                        contents[j] = '';
                    }

                    if ( this.selectedFilterItems[j] !== undefined
                        && this.selectedFilterItems[j] !== null
                        && this.selectedFilterItems[j] !== contents[j] ) {
                        foundFiltered = true; // 找到，当前列过滤
                        break;
                    }
                  }
                  // 如果没有找到过滤的，跳过
                  if (foundFiltered) {
                      continue;
                  }
              }

              // 开始重建过滤项
              for (let j = 0; j < this.cols.length; j++) {
                  const startIndex = j;  // 4位头前面4个字段去掉
                  // console.log('startIndex----------->' + startIndex + ' j = ' + j + ' i = ' + i);
                  //   if (i === 0 ) {

                  if (filterItems[startIndex] === undefined) {
                    filterItems[startIndex] = new Array<SelectItem>();
                    // console.log('startIndex----------->' + startIndex + '   ' + filterItems[startIndex]);
                  }

                  if (contents[j] === undefined) {
                    contents[j] = '';
                  }
                  // console.log(filterItems);
                  if (!this.isDuplicat(filterItems[startIndex], contents[j])) {
                      const filterItem = {
                          label: contents[j],
                          value: contents[j]
                      };
                      filterItems[startIndex].push(filterItem);
                  }

                  contentItem[('content' + j)] = contents[j];
              }
              vehicleTestableSws.push(contentItem);
          }

          this.vehicleTestableSws = vehicleTestableSws;
          // console.log(this.vehicleTestableSws );
          for (let j = 0; j < this.cols.length; j++) {
            // console.log('startIndex----------->' + j + '   ', filterItems[j]);
            if (this.cols[j].header.includes('年') || this.cols[j].header.includes('year') || this.cols[j].header.includes('Year')) {
                filterItems[j].sort(this.contrastP);
            } else {
                filterItems[j].sort(this.contrastM);
            }

            if (filterItems[j][0].value != null) {
                if (this.lang === 'CN') {
                    filterItems[j].splice(0, 0, { label: '所有', value: null });
                } else {
                  filterItems[j].splice(0, 0, { label: 'All', value: null });
                }
            }
          }

          this.filterItems = filterItems;

      }
  }

contrastP(obj1, obj2) {
    const val1 = obj1.value;
    const val2 = obj2.value;
    return val2.localeCompare(val1);
    // if (val1 > val2) {
    //     return -1;
    // } else if (val1 < val2) {
    //     return 1;
    // } else {
    //     return 0;
    // }
}

contrastM(obj1, obj2) {
    const val1 = obj1.value;
    const val2 = obj2.value;
    return val1.localeCompare(val2);
    // if (val1 < val2 || val1.trim() === '') {
    //     return -1;
    // } else if (val1 > val2 || val2.trim() === '') {
    //     return 1;
    // } else {
    //     return 0;
    // }
}

  onReset() {
    if(this.resetting || !this.filterChanged )  { return; }
    this.filterChanged = false;
    this.resetting = true;
    this.selectedFilterItems = [];
    this.buildColums();
    this.buildContentAndFilters();
    this.initPage();
    this.resetting = false;
  }

  isDuplicat(filterItem, label): boolean {
      for (let i = 0; filterItem && i <  filterItem.length; i++) {
          const element = filterItem[i];
          // console.log(element, label, (element.label === label) );
          if (element.label === label) {
              return true;
          }
      }
      // console.log('----------------->4');
      return false;
  }

  onChange(col, event) {
    if (this.debug) { window.console.log(col, event); }
    // window.console.log( this.selectedFilterItems );
        //   dt.filter(event.value, field, 'equals');
    this.initPage();
    this.selectedFilterItems[col] = event.value;
    this.buildContentAndFilters();
    this.filterChanged = true;
  }

  onBrandFilter(value, field, brand) {
      if (this.debug) { window.console.log(value, field); }
      brand.filter(value, field, 'contains');
  }

  onVersionClick(brand) {
    if (this.debug) { window.console.log( '------------>2 on version click', brand);}
    // let version: string = brand.versionDesc;
    // version =   version.replace(/[\\r]/g, ''); // .replace(/[\n]/g, '<br>');
    // version =   version.replace(/[\\n]/g, '<br>');
    this.dialog.title = (this.lang === 'CN' ? '版本号：' : ' Version:') + brand.version ;
    this.dialog.curLatestVersionInfo = brand.versionDesc;
    this.display = true;

    setTimeout(() => {
        document.getElementById('closedialog').addEventListener('touchstart', ev => {
            if (this.display) {
                window.console.log('----->1');
                window.console.log(ev);
            //   ev.preventDefault();
            //   ev.stopImmediatePropagation();
                this.display = false;
                this.touchContent = false;
            //   window.console.log('----->1', ev);
            }
        }, { passive: false });

        document.getElementById('diaContent').addEventListener('touchstart', ev => {
            this.touchContent = true;
        }, { passive: false });
    }, 100);

  }

  onTypeRowSelect(event) {
      if (this.debug) { window.console.log(event.data); }
      this.selectedFilterItems = [];
      this.loadBrand(event.data.id);
  }

  onTypeSelected(id) {
    // console.log(id, this.selectedType);
    this.initPage();
    this.loadBrand(id);
  }

  onBrandRowSelect(event) {
      if (this.debug) { window.console.log(event.data); }
      this.selectedBrand = event.data;
      this.selectedBrandType = this.selectedBrand.types[0];
      this.selectedFilterItems = [];
      this.loadAll();
  }

  onBrandSelected(selectedBrand) {
    if (this.debug) { window.console.log(selectedBrand); }
    // this.selectedBrand = event.data;
    this.initPage();
    this.selectedBrandType = this.selectedBrand.types[0];
    this.selectedFilterItems = [];
    this.loadAll();
  }

  onDetailClick() {
    //   this.selectedBrand = brand;
    //   this.selectedBrandType = type;
    this.initPage();
    this.selectedFilterItems = [];
    this.loadAll();
  }

  onSpecialClick(strSpecialCodes) {
      if (this.debug) { window.console.log( '1onSpecialClick------>', this.specialVehicleContents); }
      const arrSpecialCodes = strSpecialCodes.split(',');
      if (this.debug) { window.console.log( '2onSpecialClick------>', arrSpecialCodes, this.specialVehicleContents); }
      let strSpecial = '';
      if (this.specialVehicleContents === undefined) {
        strSpecial = (this.lang === 'CN' ? ' 找不到相应功能' : ' Function not found');
      } else {
          arrSpecialCodes.forEach(specialCode => {
              // 构造数据说明字符串
              let funcContent = this.specialVehicleContents[specialCode.trim()];
              if (funcContent === undefined){
                funcContent = (this.lang === 'CN' ? ' 找不到相应功能' : 'Function not found');
              }

              strSpecial = strSpecial + '<div><span style="' + 'color: red' + '">'
                + specialCode + '</span>: ' + funcContent + '</div>';
          });
      }

      if (this.debug) { window.console.log( '4onSpecialClick------>', strSpecial); }
      // 显示对话框
      this.dialog.title = this.lang === 'CN' ? ' 特殊功能代号说明' : ' Special function code description';

      this.dialog.curLatestVersionInfo = strSpecial;
      this.display = true;

      setTimeout(() => {
        document.getElementById('closedialog').addEventListener('touchstart', ev => {
            if (this.display) {
                // window.console.log('----->1');
                // window.console.log(ev);
            //   ev.preventDefault();
            //   ev.stopImmediatePropagation();
                this.display = false;
            //   window.console.log('----->1', ev);
            }
        }, { passive: false });
        document.getElementById('diaContent').addEventListener('touchstart', ev => {
            this.touchContent = true;
        }, { passive: false });
    }, 100);
  }

  isContain(content: string, substr: string) {
      // if (this.debug) { window.console.log( content, substr);
      return content.includes(substr);
  }

  needShow(curcol) {
    let found = false;
    for (const iterator of this.selectedShowCols) {
        // if (this.debug) { window.console.log('==================>', iterator,  curcol.field);
        if (iterator === curcol.field) {
            found = true;
        }
    }

    return found;
  }

  onShowColsSelect(event) {
    if (this.debug) { window.console.log(event, this.selectedShowCols); }
    this.selectedShowCols = event.value;
  }

  getPageTips() {
      return 'Showing {first} to {last} of {totalRecords} entries';
  }

  showCol(col) {
    // console.log(this.showCols);
    for (const iterator of this.showCols) {
        if (col.field === iterator.value) {
            return true;
        }
    }
    return false;
  }

  getPageInfo() {
    // const pages: number = parseInt(((this.vehicleTestableSws.length / this.rowsPerPage) + 1).toString(), 0);
    const pages: number = Math.ceil(this.vehicleTestableSws.length / this.rowsPerPage);
    // console.log(this.vehicleTestableSws.length / this.rowsPerPage, this.vehicleTestableSws.length, 
    //     this.rowsPerPage, (this.vehicleTestableSws.length / this.rowsPerPage) + 1, pages);
    return this.lang === 'CN'
        ? '共 <span style="' + 'color: red;' + '">'
        + pages + '</span> 页 ' + ' / <span style="' + 'color: red' + '">' + this.vehicleTestableSws.length + '</span> 条数据'
        : 'Total <span style="' + 'color: red;' + '">'
        + pages + '</span> pages ' + ' \/ <span style="' + 'color: red' + '">' + this.vehicleTestableSws.length + '</span> entries';
  }

  paginate(event) {
    // console.log(event);
    this.rowsPerPage = event.rows;
    this.first = event.first;
    this.currentPage = event.page + 1;
  }

  pageChanged(event) {
    // console.log(this.vehicleTestableSws.length / this.rowsPerPage, this.vehicleTestableSws.length, this.rowsPerPage);
    // const pages: number = parseInt(((this.vehicleTestableSws.length / this.rowsPerPage) + 1).toFixed(0), 0);
    // const pages: number = parseInt(((this.vehicleTestableSws.length / this.rowsPerPage) + 1).toString(), 0);
    const pages: number = Math.ceil(this.vehicleTestableSws.length / this.rowsPerPage);
    if (event < 1) {
        this.currentPage = 1;
    } else if( event > pages) {
        this.currentPage = pages;
    }
    this.first = (this.currentPage - 1) * this.rowsPerPage;
  }

  @HostListener('document:touchmove', ['$event'])
  onTouchMove($event: TouchEvent): void {
    // window.console.log('event = ', $event);
    if($event.type === 'touchmove' && this.display) {
        // $event.preventDefault();
        $event.stopPropagation();
    }
  }

  initPage(): void {
    this.first = 0;
    this.currentPage = 1;
  }

  checkShowFilter(item: string): boolean {
    // window.console.log(item);
    return item.includes('版本信息')
    || item.includes('读码')
    || item.includes('清码')
    || item.includes('数据流')
    || item.includes('动作测试')
    || item.includes('读故障码')
    || item.includes('清故障码')
    || item.includes('电脑信息')
    || item.toLocaleLowerCase().includes('Version'.toLocaleLowerCase())
    || item.toLocaleLowerCase().includes('Read Code'.toLocaleLowerCase())
    || item.toLocaleLowerCase().includes('Clear Code'.toLocaleLowerCase())
    || item.toLocaleLowerCase().includes('DataStream'.toLocaleLowerCase())
    || item.toLocaleLowerCase().includes('Information'.toLocaleLowerCase())
    || item.toLocaleLowerCase().includes('TroubleCode'.toLocaleLowerCase())
    || item.toLocaleLowerCase().includes('TroubleCode'.toLocaleLowerCase())
    || item.toLocaleLowerCase().includes('Active test'.toLocaleLowerCase());
  }
}
